import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import BenefitsSection from './components/BenefitsSection';
import HowItWorks from './components/HowItWorks';
import SeoArticlesSection from './components/SeoArticlesSection';
import ArticleCTA from './components/ArticleCTA';
import FAQSection from './components/FAQSection';

export default function Home() {

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <HeroSection />
        <CategoryDropdown />
        <CategoryGrid />
        <AboutSection />
        <BenefitsSection />
        <HowItWorks />
        <SeoArticlesSection />
        <ArticleCTA />
        <FAQSection />
      </main>
      <Footer />
    </div>
  );
}